import React, { useCallback, useLayoutEffect, useMemo, useRef } from 'react';
import { useAuth } from 'react-oidc-context';
import { createHitlApi } from '../../services/hitl';
import HitlPane from './HitlPane';
import { HitlApiContext } from './HitlApiContext';

/** Existing standalone Companion also binds every HITL call to active OIDC. */
export default function AuthenticatedHitlPane(props: React.ComponentProps<typeof HitlPane>) {
  const auth = useAuth();
  const subject = auth.isAuthenticated ? auth.user?.profile.sub ?? null : null;
  const accessToken = subject ? auth.user?.access_token ?? null : null;
  const identity = useRef({ subject, accessToken, source: props.lectureId, generation: 0 });
  if (identity.current.subject !== subject || identity.current.accessToken !== accessToken || identity.current.source !== props.lectureId) {
    identity.current = { subject, accessToken, source: props.lectureId, generation: identity.current.generation + 1 };
  }
  const current = identity.current;
  const client = useMemo(() => createHitlApi(accessToken), [accessToken]);
  const callbackRef = useRef(props.onAgentPausedChange);
  callbackRef.current = props.onAgentPausedChange;
  const pause = useCallback((paused: boolean) => {
    if (identity.current === current) callbackRef.current?.(paused);
  }, [current]);
  useLayoutEffect(() => { pause(true); }, [pause]);
  return <HitlApiContext.Provider value={client}><HitlPane key={current.generation} {...props} onAgentPausedChange={pause} /></HitlApiContext.Provider>;
}
